import React from 'react'
import ShowImage from './ShowImage'
import CountdownTimer from '@/app/promotion/component/CountdownTimer'
const CampaignComponent = ({ data }) => {
    const { image, mob_image, slider_images, offers, category, brand, showOffer, showCtaButton, type, fieldValue, showTimer, timerDate, timerBoxColor, timerPosition, timerHeading } = data
    const ids = category?.map(item => item.value).join(',');

    // Construct the URL
    let url = '/promotion'
    if (type == 'price') {
        url = url + `?price=${fieldValue}`
    }
    if (type == 'limited') {
        url = url + `?limited=${fieldValue}`
    }
    if (type == 'category') {
        const ids = category?.map(item => item.value).join(',');
        // Construct the URL
        url += `?parentCategory=${ids}`;
    }
    if (type == 'brand') {
        const ids = brand?.map(item => item.value).join(',');
        // Construct the URL
        url += `?brand=${ids}`;
    }
    if (type == 'rating') {
        url += `?rating=true`
    }

    let timerStyle = ''
    if (timerPosition === 'left') {
        timerStyle = 'absolute top-5 max-md:left-1/2 max-md:-translate-x-1/2 md:top-1/2 md:left-5 lg:left-12 xl:left-20 md:-translate-y-1/2'
    }

    if (timerPosition === 'right') {
        timerStyle = 'absolute top-5 max-md:left-1/2 max-md:-translate-x-1/2 md:top-1/2 md:right-5 lg:right-12 xl:right-20 md:-translate-y-1/2'
    }
    if (timerPosition === 'center') {
        timerStyle = 'absolute top-5 left-1/2 -translate-x-1/2 '
    }
    const parseEndOfDayLocal = (dateStr) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day, 23, 59, 59); // Local time
    };

    return (
        <div>
            <a target='_blank' href={url} className='relative w-full block'>
                <ShowImage
                    image={image}
                    mobImage={mob_image}
                // style='w-full h-full'
                />
                {
                    showTimer && timerDate ? (
                        <div className={timerStyle}>
                            <CountdownTimer timerHeading={timerHeading} endDate={parseEndOfDayLocal(timerDate)} bgColor={timerBoxColor} />
                        </div>
                    ) : null
                }
            </a>
            {
                showOffer ? (
                    <div className='max-w-6xl mx-auto grid grid-cols-4 gap-2 md:gap-4 mt-4'>
                        {
                            slider_images?.map((d, idx) =>
                                <OfferCard
                                    key={d.heading + idx}
                                    data={d}
                                />
                            )
                        }
                    </div>
                ) : null
            }
            {
                showCtaButton ? (
                    <div className='mt-9 max-w-5xl mx-auto flex flex-row items-center justify-center flex-wrap  gap-2 md:gap-4 '>
                        {
                            offers?.map((d, idx) => (
                                <OfferPrice key={d.price + idx + d.heading} data={d} />
                            ))
                        }
                    </div>
                ) : null
            }

        </div>
    )
}

export default CampaignComponent


const OfferCard = ({ data }) => {
    const { heading, image_url, sub_heading, offer_label, tag, categoryIds, type, fieldValue, brandIds } = data;
    // Extract the IDs and join them
    const ids = categoryIds?.map(item => item.value).join(',');

    // Construct the URL
    let url = '/promotion'
    if (type == 'price') {
        url = url + `?price=${fieldValue}#product`
    }
    if (type == 'limited') {
        url = url + `?limited=${fieldValue}#product`
    }
    if (type == 'category') {
        const ids = categoryIds?.map(item => item.value).join(',');
        // Construct the URL
        url += `?category=${ids}#product`;
    }
    if (type == 'brand') {
        const ids = brandIds?.map(item => item.value).join(',');
        // Construct the URL
        url += `?brand=${ids}#product`;
    }
    if (type == 'rating') {
        url += `?rating=true#product`
    }

    return (
        <a target='_blank' href={`${url}#product`} className="relative rounded-xl overflow-hidden group cursor-pointer block">
            <img src={image_url} alt={'promotion'} className="w-full h-20 sm:h-60 md:h-80 object-cover" />

            <div
                className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex flex-col justify-center items-center text-center 
                bg-[#FFFFFFA1] opacity-0 scale-95 transition-all duration-300 
                md:group-hover:opacity-100 md:group-hover:scale-100 p-5"
            >
                <h3 className="font-semibold">{heading}</h3>
                {sub_heading ? (<p className="my-2 font-medium text-sm">{sub_heading}</p>) : null}
                <p className="text-sm text-[#DB1414] font-semibold">
                    {offer_label}
                </p>
            </div>
        </a>
    );
};


const OfferPrice = ({ data }) => {
    const { heading, price, bgColor, type, fieldValue, categoryIds, brandIds } = data;

    const background = bgColor || '#000000';
    let url = '/promotion'
    if (type == 'price') {
        url = url + `?price=${fieldValue}#product`
    }
    if (type == 'limited') {
        url = url + `?limited=${fieldValue}#product`
    }
    if (type == 'category') {
        const ids = categoryIds?.map(item => item.value).join(',');
        // Construct the URL
        url += `?category=${ids}#product`;
    }
    if (type == 'brand') {
        const ids = brandIds?.map(item => item.value).join(',');
        // Construct the URL
        url += `?brand=${ids}#product`;
    }
    if (type == 'rating') {
        url += `?rating=true#product`
    }
    return (
        <a
            href={url}
            target='_blank'
            className="basis-40 sm:basis-60 h-10 flex flex-col justify-center items-center text-white rounded-xl cursor-pointer "
            style={{ backgroundColor: background }}
        >
            <p className=" text-xs md:text-sm text-center">{heading}</p>
            {/* {type == 'price' ? (<p className="text-sm md:text-2xl font-semibold text-center">₹{price}</p>) : null} */}

        </a>
    );
};
